var map = {
	"./add.svg": [
		"0ef4",
		"icon-add-svg"
	],
	"./area.svg": [
		"01563",
		"icon-area-svg"
	],
	"./arrow-down.svg": [
		"bee2c",
		"icon-arrow-down-svg"
	],
	"./arrow-left.svg": [
		"d4f3",
		"icon-arrow-left-svg"
	],
	"./arrow-long-left.svg": [
		"1b3b",
		"icon-arrow-long-left-svg"
	],
	"./arrow-long-right.svg": [
		"4b5c",
		"icon-arrow-long-right-svg"
	],
	"./arrow-right-2.svg": [
		"eccd",
		"icon-arrow-right-2-svg"
	],
	"./arrow-right.svg": [
		"116c",
		"icon-arrow-right-svg"
	],
	"./back.svg": [
		"53cf",
		"icon-back-svg"
	],
	"./bicycle.svg": [
		"1bff",
		"icon-bicycle-svg"
	],
	"./billing.svg": [
		"facb",
		"icon-billing-svg"
	],
	"./book.svg": [
		"cb64",
		"icon-book-svg"
	],
	"./branding.svg": [
		"2e80",
		"icon-branding-svg"
	],
	"./bulb-2.svg": [
		"774e",
		"icon-bulb-2-svg"
	],
	"./bulb.svg": [
		"da75",
		"icon-bulb-svg"
	],
	"./channel.svg": [
		"e534",
		"icon-channel-svg"
	],
	"./chat.svg": [
		"438f",
		"icon-chat-svg"
	],
	"./chatfood-logo.svg": [
		"31ce",
		"icon-chatfood-logo-svg"
	],
	"./check-circle.svg": [
		"61d4",
		"icon-check-circle-svg"
	],
	"./check.svg": [
		"addc",
		"icon-check-svg"
	],
	"./checkmark-circle.svg": [
		"26e4",
		"icon-checkmark-circle-svg"
	],
	"./checkmark.svg": [
		"6b78",
		"icon-checkmark-svg"
	],
	"./close.svg": [
		"e041",
		"icon-close-svg"
	],
	"./copy-new.svg": [
		"ca8e",
		"icon-copy-new-svg"
	],
	"./copy.svg": [
		"3461",
		"icon-copy-svg"
	],
	"./credit-card.svg": [
		"5799",
		"icon-credit-card-svg"
	],
	"./cross-modal.svg": [
		"0341",
		"icon-cross-modal-svg"
	],
	"./cross-widget.svg": [
		"f963",
		"icon-cross-widget-svg"
	],
	"./customers-menu.svg": [
		"7b25",
		"icon-customers-menu-svg"
	],
	"./dashboard-menu.svg": [
		"fd0c",
		"icon-dashboard-menu-svg"
	],
	"./data.svg": [
		"c701",
		"icon-data-svg"
	],
	"./delete.svg": [
		"c70d",
		"icon-delete-svg"
	],
	"./delivery-areas-sidebar.svg": [
		"697d",
		"icon-delivery-areas-sidebar-svg"
	],
	"./dine-in.svg": [
		"729b",
		"icon-dine-in-svg"
	],
	"./discount.svg": [
		"6fde",
		"icon-discount-svg"
	],
	"./download.svg": [
		"96bd",
		"icon-download-svg"
	],
	"./email-reminder.svg": [
		"1cfa",
		"icon-email-reminder-svg"
	],
	"./email.svg": [
		"4f6b2",
		"icon-email-svg"
	],
	"./email2.svg": [
		"7879",
		"icon-email2-svg"
	],
	"./export.svg": [
		"b291",
		"icon-export-svg"
	],
	"./eye-slash.svg": [
		"e0c3",
		"icon-eye-slash-svg"
	],
	"./eye.svg": [
		"a957",
		"icon-eye-svg"
	],
	"./facebook.svg": [
		"0a9e4",
		"icon-facebook-svg"
	],
	"./feather.svg": [
		"d5ff",
		"icon-feather-svg"
	],
	"./gift.svg": [
		"5862",
		"icon-gift-svg"
	],
	"./headphones.svg": [
		"ebf9",
		"icon-headphones-svg"
	],
	"./heart.svg": [
		"6b145",
		"icon-heart-svg"
	],
	"./help-menu.svg": [
		"142e",
		"icon-help-menu-svg"
	],
	"./help.svg": [
		"f9b6",
		"icon-help-svg"
	],
	"./house.svg": [
		"e26b",
		"icon-house-svg"
	],
	"./info-circle.svg": [
		"84fd",
		"icon-info-circle-svg"
	],
	"./inventory-menu.svg": [
		"8d15",
		"icon-inventory-menu-svg"
	],
	"./knowledge.svg": [
		"a67b",
		"icon-knowledge-svg"
	],
	"./link.svg": [
		"1bba",
		"icon-link-svg"
	],
	"./live-orders-menu.svg": [
		"45f9",
		"icon-live-orders-menu-svg"
	],
	"./loading.svg": [
		"524b",
		"icon-loading-svg"
	],
	"./lock.svg": [
		"f2c9",
		"icon-lock-svg"
	],
	"./logout-menu.svg": [
		"c8f7",
		"icon-logout-menu-svg"
	],
	"./loyalty.svg": [
		"a7b4",
		"icon-loyalty-svg"
	],
	"./loyalty2.svg": [
		"8fa8",
		"icon-loyalty2-svg"
	],
	"./map-marker.svg": [
		"0d41",
		"icon-map-marker-svg"
	],
	"./marketing-menu.svg": [
		"849f",
		"icon-marketing-menu-svg"
	],
	"./megaphone.svg": [
		"e2cb",
		"icon-megaphone-svg"
	],
	"./menu-menu.svg": [
		"1d8e",
		"icon-menu-menu-svg"
	],
	"./menu.svg": [
		"206b",
		"icon-menu-svg"
	],
	"./min-basket.svg": [
		"8a81",
		"icon-min-basket-svg"
	],
	"./min-order.svg": [
		"8756",
		"icon-min-order-svg"
	],
	"./minus.svg": [
		"a3b1",
		"icon-minus-svg"
	],
	"./money.svg": [
		"7d02",
		"icon-money-svg"
	],
	"./more-trafic.svg": [
		"b9e5",
		"icon-more-trafic-svg"
	],
	"./motorcycle.svg": [
		"4009",
		"icon-motorcycle-svg"
	],
	"./online-payments.svg": [
		"b126",
		"icon-online-payments-svg"
	],
	"./order-history-menu.svg": [
		"b00b",
		"icon-order-history-menu-svg"
	],
	"./order-type.svg": [
		"c503",
		"icon-order-type-svg"
	],
	"./outlet.svg": [
		"21c3",
		"icon-outlet-svg"
	],
	"./outlets-menu.svg": [
		"69ea",
		"icon-outlets-menu-svg"
	],
	"./paint-brush.svg": [
		"2ba7",
		"icon-paint-brush-svg"
	],
	"./pat.svg": [
		"1249",
		"icon-pat-svg"
	],
	"./pause-orders-menu.svg": [
		"a880",
		"icon-pause-orders-menu-svg"
	],
	"./pencil.svg": [
		"d0a2",
		"icon-pencil-svg"
	],
	"./people.svg": [
		"a1f1",
		"icon-people-svg"
	],
	"./percentage.svg": [
		"bb65",
		"icon-percentage-svg"
	],
	"./phone.svg": [
		"0d67",
		"icon-phone-svg"
	],
	"./phone2.svg": [
		"8780",
		"icon-phone2-svg"
	],
	"./play.svg": [
		"c2dc",
		"icon-play-svg"
	],
	"./plus-circle-light.svg": [
		"1726",
		"icon-plus-circle-light-svg"
	],
	"./plus-circle.svg": [
		"6e4b",
		"icon-plus-circle-svg"
	],
	"./plus.svg": [
		"0387",
		"icon-plus-svg"
	],
	"./preferences.svg": [
		"0c09d",
		"icon-preferences-svg"
	],
	"./preview.svg": [
		"512b",
		"icon-preview-svg"
	],
	"./profile-menu.svg": [
		"eabc",
		"icon-profile-menu-svg"
	],
	"./pulse.svg": [
		"404c",
		"icon-pulse-svg"
	],
	"./qr-code.svg": [
		"edbe",
		"icon-qr-code-svg"
	],
	"./rating-star.svg": [
		"e17a",
		"icon-rating-star-svg"
	],
	"./rating.svg": [
		"7ba4",
		"icon-rating-svg"
	],
	"./refresh.svg": [
		"1603",
		"icon-refresh-svg"
	],
	"./reports.svg": [
		"9ab2",
		"icon-reports-svg"
	],
	"./rocket.svg": [
		"67e9",
		"icon-rocket-svg"
	],
	"./saved-messages.svg": [
		"0c93",
		"icon-saved-messages-svg"
	],
	"./search.svg": [
		"134f",
		"icon-search-svg"
	],
	"./settings.svg": [
		"70bc",
		"icon-settings-svg"
	],
	"./shop-circle.svg": [
		"8e47",
		"icon-shop-circle-svg"
	],
	"./shop-new.svg": [
		"467c",
		"icon-shop-new-svg"
	],
	"./shop.svg": [
		"6ea8",
		"icon-shop-svg"
	],
	"./shopping-basket.svg": [
		"20f0",
		"icon-shopping-basket-svg"
	],
	"./sort-asc.svg": [
		"19b9",
		"icon-sort-asc-svg"
	],
	"./sort-desc.svg": [
		"d472",
		"icon-sort-desc-svg"
	],
	"./sort-none.svg": [
		"7ca6",
		"icon-sort-none-svg"
	],
	"./sorting.svg": [
		"8a09",
		"icon-sorting-svg"
	],
	"./sparkle.svg": [
		"7903",
		"icon-sparkle-svg"
	],
	"./speech-bubble.svg": [
		"e757",
		"icon-speech-bubble-svg"
	],
	"./star.svg": [
		"5fb9",
		"icon-star-svg"
	],
	"./tag.svg": [
		"4c6c",
		"icon-tag-svg"
	],
	"./thick-cross.svg": [
		"4f1cf",
		"icon-thick-cross-svg"
	],
	"./times-circle-outline.svg": [
		"7bd2",
		"icon-times-circle-outline-svg"
	],
	"./times-circle.svg": [
		"1ef9",
		"icon-times-circle-svg"
	],
	"./times.svg": [
		"cc6f",
		"icon-times-svg"
	],
	"./tips.svg": [
		"e355",
		"icon-tips-svg"
	],
	"./toggles.svg": [
		"ae1a",
		"icon-toggles-svg"
	],
	"./transaction.svg": [
		"0dd6",
		"icon-transaction-svg"
	],
	"./trash.svg": [
		"44b8",
		"icon-trash-svg"
	],
	"./upload.svg": [
		"29ef",
		"icon-upload-svg"
	],
	"./user-circle.svg": [
		"ee39",
		"icon-user-circle-svg"
	],
	"./users-menu.svg": [
		"6eb2",
		"icon-users-menu-svg"
	],
	"./users.svg": [
		"afc9",
		"icon-users-svg"
	],
	"./vip.svg": [
		"1fe7",
		"icon-vip-svg"
	],
	"./whatsapp.svg": [
		"7ad2",
		"icon-whatsapp-svg"
	],
	"./zoom-in.svg": [
		"6b40",
		"icon-zoom-in-svg"
	],
	"./zoom-out.svg": [
		"c1e4",
		"icon-zoom-out-svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "cc2e";
module.exports = webpackAsyncContext;